<template>
  <v-dialog v-model="dialogVisible" max-width="620" persistent>
    <v-card class="course-form-card rounded-lg">
      <v-card-title class="form-header px-6 py-4">
        <span class="text-lg font-bold text-white">{{ isEdit ? 'Edit Course' : 'Create New Course' }}</span>
        <v-spacer />
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-6">
        <v-form ref="courseForm" v-model="valid" lazy-validation>
          <v-text-field
            v-model="form.title"
            label="Course Title"
            :rules="[v => !!v || 'Title is required']"
            outlined
            dense
            class="mb-1"
            prepend-inner-icon="mdi-book-open-variant"
          />

          <v-textarea
            v-model="form.description"
            label="Description"
            :rules="[v => !!v || 'Description is required']"
            outlined
            dense
            rows="3"
            class="mb-1"
            prepend-inner-icon="mdi-text"
          />

          <v-select
            v-model="form.category"
            :items="categories"
            label="Category"
            :rules="[v => !!v || 'Category is required']"
            outlined
            dense
            class="mb-1"
            prepend-inner-icon="mdi-tag-outline"
          />

          <v-select
            v-model="form.difficulty"
            :items="difficulties"
            label="Difficulty Level"
            :rules="[v => !!v || 'Difficulty is required']"
            outlined
            dense
            class="mb-1"
            prepend-inner-icon="mdi-signal"
          />

          <v-text-field
            v-model="form.instructor"
            label="Instructor Name"
            :rules="[v => !!v || 'Instructor is required']"
            outlined
            dense
            class="mb-1"
            prepend-inner-icon="mdi-account-tie"
          />

          <v-text-field
            v-model="form.thumbnail"
            label="Thumbnail URL (optional)"
            outlined
            dense
            prepend-inner-icon="mdi-image-outline"
          />
        </v-form>
      </v-card-text>

      <v-card-actions class="px-6 pb-5">
        <v-spacer />
        <v-btn text class="mr-2 normal-case" @click="close">Cancel</v-btn>
        <v-btn
          color="#21427d"
          class="white--text normal-case px-6 rounded-lg"
          :disabled="!valid"
          @click="submit"
          depressed
        >
          <v-icon left small>{{ isEdit ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
          {{ isEdit ? 'Update' : 'Create Course' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { CATEGORIES, DIFFICULTIES } from './learningData'

export default {
  name: 'CourseFormDialog',
  props: {
    value: { type: Boolean, default: false },
    editData: { type: Object, default: null }
  },
  data() {
    return {
      valid: false,
      categories: CATEGORIES,
      difficulties: DIFFICULTIES,
      form: {
        title: '',
        description: '',
        category: '',
        difficulty: '',
        instructor: '',
        thumbnail: ''
      }
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    },
    isEdit() {
      return !!this.editData
    }
  },
  watch: {
    value(val) {
      if (val && this.editData) {
        this.form = {
          title: this.editData.title || '',
          description: this.editData.description || '',
          category: this.editData.category || '',
          difficulty: this.editData.difficulty || '',
          instructor: this.editData.instructor || '',
          thumbnail: this.editData.thumbnail || ''
        }
      } else if (val) {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        title: '',
        description: '',
        category: '',
        difficulty: '',
        instructor: '',
        thumbnail: ''
      }
      if (this.$refs.courseForm) {
        this.$refs.courseForm.resetValidation()
      }
    },
    submit() {
      if (this.$refs.courseForm.validate()) {
        this.$emit('save', { ...this.form })
        this.close()
      }
    },
    close() {
      this.resetForm()
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.course-form-card {
  overflow: hidden;
}
.form-header {
  background: linear-gradient(135deg, #21427d 0%, #3a6bc5 100%);
}
</style>
